/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import gatewayModelFieldsetTemplate from './gateway-model-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function GatewayModelDirective($compile, $templateCache, $translate, types) {
    var linker = function (scope, element) {
        var template = $templateCache.get(gatewayModelFieldsetTemplate);
        element.html(template);
        scope.types = types;
        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            gatewayModel: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/gateway-model/gateway-model.directive.js